import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions(["addPayment"]),

    handleEftposPayment(value) {
      this.sentToEftpos = parseFloat(value).toFixed(2);
      /* TODO: Fire callback to App wrapper to send to EFTPOS machine */
      if (window.Android && window.Android.chargeEFTPOS) {
        window.Android.chargeEFTPOS(parseFloat(value).toFixed(2).toString(), this.eftposSettings[0].ip, parseInt(this.eftposSettings[0].port), null);
        this.eftposBusy = true;
      } else if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.EFTPOSHandler.postMessage({
          action: "payNow",
          additionalData: {
            amount: parseFloat(value).toFixed(2).toString(),
            ip: this.eftposSettings[0].ip,
            port: parseInt(this.eftposSettings[0].port),
            company: localStorage.getItem("company"),
          },
        });
        this.eftposBusy = true;
      } else {
        this.addPayment({ type: "eftpos", value: value});
      }
      this.splitOrderCurrentTotal = 0;
    },

    handleCheckResponse(message) {
      let msg = JSON.parse(message);
      if (msg[0] == "APPROVED") {
        this.$notify({
          text: "EFTPOS: The last payment was successful",
          type: "success",
          duration: 5000,
        });
        let companion = { products: this.products, payment: msg[1], payment_message: msg[0] };
        this.channel.push("cart:state", companion);
        if (this.remaining == 0) {
          this.completeTransaction();
        }
      }
    },

    eftposHandler(message) {
      this.splitOrderCurrentTotal = 0;
      this.eftposBusy = false;
      let msg = JSON.parse(message);
      if (msg[0] == "APPROVED") {
        //this.checkEftposFee(msg[1]);
        if (this.refunding) {
          this.addPayment({ type: "refund", refund_method: "eftpos", value: -1 * parseFloat(msg[2]) });
          this.refunding = false;
        } else {
          this.addPayment({ type: "eftpos", value: parseFloat(msg[1]), id: this.purID  });
        }
        this.$notify({
          text: "EFTPOS: Approved",
          type: "success",
          duration: 5000,
        });
      } else if (msg[0] == "SIGNATURE APPROVED") {
        //this.checkEftposFee(msg[1]);
        this.addPayment({ type: "eftpos", value: parseFloat(msg[1]), id: this.purID  });
        this.$notify({
          text: "EFTPOS: Signature Approved",
          type: "success",
          duration: 5000,
        });
      } else if (msg[0] == "ERROR" && !this.getKiosk) {
        this.$notify({
          text: "EFTPOS: Terminal busy, please try again",
          type: "error",
          duration: 5000,
        });
      } else if (this.getKiosk) {
        this.$notify({
          text: "EFTPOS: " + msg[0],
          type: "error",
          duration: 5000,
        });
      } else {
        this.$notify({
          text: "EFTPOS: " + msg[0],
          type: "error",
          duration: -1,
        });
      }
      let companion = { products: this.products, payment: msg[1], payment_message: msg[0] };
      this.channel.push("cart:state", companion);
      if ((this.remaining == 0 && !this.siteSettings.nameRequired) || this.getKiosk) {
        this.completeTransaction();
      }
    },

    helperAcceptSig() {
      this.eftposSig = false;
      if (window.Android && window.Android.acceptSig) {
        window.Android.acceptSig(true);
      } else if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.sigHandler.postMessage({
          action: "acceptSig",
          additionalData: {
            result: true,
          },
        });
      }
    },

    helperDeclineSig() {
      this.eftposSig = false;
      if (window.Android && window.Android.acceptSig) {
        window.Android.acceptSig(false);
      } else if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.sigHandler.postMessage({
          action: "declineSig",
          additionalData: {
            result: false,
          },
        });
      }
    },

    helperRefund(value) {
      this.refunding = true;
      this.splitOrderCurrentTotal = 0;
      //this.addPayment({ type: "refund", value: (-1 * value) });
      if (window.Android && window.Android.EFTPOSHandler) {
        console.log("need to handle the refund android side");
      } else if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.EFTPOSHandler.postMessage({
          action: "refundEFTPOS",
          additionalData: {
            ip: this.eftposSettings[0].ip,
            port: parseInt(this.eftposSettings[0].port),
            amount: parseFloat(value).toFixed(2).toString(),
            company: localStorage.getItem("company"),
          },
        });
      }
    },

    helperCheckEftposLastPayment(value) {
      // check what happened with the last payment if eftpos disconnected
      // this still needs work not returning whether the last payment was successful or not
      // just initialting a new payment
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.EFTPOSHandler.postMessage({
          action: "checkStatus",
          additionalData: {
            amount: parseFloat(value).toFixed(2).toString(),
            ip: this.eftposSettings[0].ip,
            port: parseInt(this.eftposSettings[0].port),
            company: localStorage.getItem("company"),
            purchaseID: this.purID,
          },
        });
      }
    },

    helperCancelEftpos() {
      if (window.Android && window.Android.cancelEFTPOS) {
        window.Android.cancelEFTPOS(this.eftposSettings[0].ip, parseInt(this.eftposSettings[0].port));
        this.eftposBusy = false;
      } else {
        if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.EFTPOSHandler.postMessage({
            action: "cancelEFTPOS",
            additionalData: {
              ip: this.eftposSettings[0].ip,
              port: parseInt(this.eftposSettings[0].port),
              company: localStorage.getItem("company"),
            },
          });
          this.eftposBusy = false;
        }
      }
    },
  },

  computed: {
    ...mapGetters({
      getKiosk: "getKiosk",
    }),
  },

  data() {
    return {
      eftposBusy: false,
    };
  },
};
